module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 40
// module chunks = 367